import { TUploadResponseDTO } from '@monorepo/services';
import { Action } from '@ngrx/store';
import { TExcelManagementContext, TExcelManagementInfo } from '../../types';
import { TExcelManagementActionType } from './excel-management.model';

export class UploadExcel implements Action {
  readonly type = TExcelManagementActionType.UploadExcel;
  constructor(
    public payload: {
      file: File;
      excelInfo: TExcelManagementInfo;
    },
  ) {}
}

export class UploadExcelSuccess implements Action {
  readonly type = TExcelManagementActionType.UploadExcelSuccess;
}

export class UploadExcelFailure implements Action {
  readonly type = TExcelManagementActionType.UploadExcelFailure;
}

export class DownloadExcel implements Action {
  readonly type = TExcelManagementActionType.DownloadExcel;
  constructor(public excelInfo: TExcelManagementInfo) {}
}

export class DownloadExcelSuccess implements Action {
  readonly type = TExcelManagementActionType.DownloadExcelSuccess;
  constructor() {}
}

export class DownloadExcelFailure implements Action {
  readonly type = TExcelManagementActionType.DownloadExcelFailure;
}

export class DownloadErrorExcel implements Action {
  readonly type = TExcelManagementActionType.DownloadErrorExcel;
  constructor(
    public payload: {
      errorKey: Exclude<TUploadResponseDTO['errorFileKeyOpt'], undefined>;
      excelContext: TExcelManagementContext;
    },
  ) {}
}

export class DownloadErrorExcelSuccess implements Action {
  readonly type = TExcelManagementActionType.DownloadExcelErrorSuccess;
}

export class DownloadErrorExcelFailure implements Action {
  readonly type = TExcelManagementActionType.DownloadExcelErrorFailure;
}

export type TExcelManagementActions =
  | UploadExcel
  | UploadExcelSuccess
  | UploadExcelFailure
  | DownloadExcel
  | DownloadExcelSuccess
  | DownloadExcelFailure
  | DownloadErrorExcel
  | DownloadErrorExcelSuccess
  | DownloadErrorExcelFailure;
